// extracted by css-extract-rspack-plugin
export default {"reveal":"Reveal-module__reveal","isVisible":"Reveal-module__isVisible"};